module.exports = __webpack_public_path__ + "img/figure-13.73794562.png";